const colors = {
  MAIN_COLOR: "#74080A",
  WHITE_COLOR: "#FFFFFF",
  BLUE_COLOR: "#0084ff",
};

export default colors;
